<template>
    <div class="container text-align">
        <div class="row bg-BAT">
            <div class="col-12 col-md-6 col-lg-7 card-colors gray">
                <div class="container-fluid">
                    <a class="desk" href="/categoria-catalogo"><img class="desk" src="/img-version2/icons/atras-vector.svg" alt="icon"></a>
                    <a class="text return desk" href="/categoria-catalogo">Regresar</a>
                    <div class="link-mobile">
                        <a class="mobile" href="/categoria-catalogo"><img class="mobile" src="/img-version2/icons/atras-vector-orange.svg" alt="icon"></a>
                        <a class="text return mobile" href="/categoria-catalogo">Regresar</a>
                    </div>
                    <div>
                        <h4 class="title third">{{ product.NAME }}</h4>
                        <button class="btnBlue2" type="submit">{{ product.CATEGORY }}</button>
                    </div>

                    <div class="img-product-detail d-flex justify-content-center">
                        <img class="image my-5 float-right img-fluid" :src="images.length > 0 ? url_media + images[0].replace('~/', '') : 'http://via.placeholder.com/825x412'" alt="image">
                    </div>

                </div>
            </div>

            <div class="col-12 col-md-6 col-lg-5 card-colors white">
                <div class="container-fluid my-5">
                    <div class="row titleMobil">
                        <div class="col-6 col-sm-6 col-md-12 text container-flex">
                            <p></p>Redímalo por  <strong class="secondTitle">{{ product.VALUE_POINTS }} Puntos</strong>
                        </div>
                        <div class="col-6 col-sm-6 col-md-12 text unds-points container-flex  ">
                            <div class="deskClik circles contendDeskt displayOne">
                                <div>
                                    <span class="less" @click="amount > 1 ? amount-- : ''">-</span>
                                        <label>{{ amount }} und</label>
                                    <span class="plus" @click="amount < product.INVENTORY-1 ? amount++ : ''">+</span>
                                </div>
                                <label class="und-disponibles">
                                    <p><strong>{{ product.INVENTORY }} Und</strong></p><p class="text-dis">disponibles</p>
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="reference my-3" v-if="product.CATEGORY !== 'Bono Digital'">
                        <label class="py-2">Referencia:</label>
                        <select id="reference_id">
                            <option :value="product.REFERENCE_ID" selected>
                                {{ product.REFERENCE }}
                            </option>
                        </select>
                    </div>

                    <div class="d-none d-md-block">
                        <div v-if="product.CATEGORY === 'Bono Digital'">
                            <p class="contendTwo" v-if="product.TERMS !== null">Términos y condiciones</p>
                            <p class="contendTwo" v-if="product.TERMS !== null" v-html="product.TERMS"></p>
                            <p class="contendTwo" v-else-if="product.LONG_DESCRIPTION !== null" v-html="product.LONG_DESCRIPTION"></p>
                        </div>
                        <div v-else>
                            <p v-html="product.LONG_DESCRIPTION"></p>
                        </div>
                    </div>


                    <!-- <div class="container-fluid my-5">
                        <div class="row row-cols-12 justify-content-around">
                            <div class="col">
                                <div v-if="loading === 0">
                                    <a class="returnH desk"  @click="addProductToCart(true)">Redimir ahora </a>
                                    <a class="returnH mobile"  @click="addProductToCart(true)">Redimir ahora</a>
                                </div>
                                <div v-else>
                                    <a class="returnH mobile">Redimir ahora</a>
                                </div>
                            </div>
                            <div class="col">
                                <button v-if="loading === 0" class="btnBlue addCar" type="submit" @click="addProductToCart(false)">Agregar al carrito</button>
                                <button v-else class="btnBlue" type="submit">Agregar al carrito</button>
                            </div>
                        </div>
                    </div> -->

                    <div class="row">
                        <div class="col-12 col-md-12 col-lg-6 order-2 order-lg-1 d-flex justify-content-center">
                            <div v-if="loading === 0">
                                <a class="returnH desk"  @click="addProductToCart(true)">Redimir ahora </a>
                                <a class="returnH mobile"  @click="addProductToCart(true)">Redimir ahora</a>
                            </div>
                            <div v-else>
                                <a class="returnH mobile">Redimir ahora</a>
                            </div>
                        </div>
                        <div class="col-12 col-md-12 col-lg-6 order-1 order-lg-2 mb-3 d-flex justify-content-center">
                            <button v-if="loading === 0" class="btnBlue addCar" type="submit" @click="addProductToCart(false)">Agregar al carrito</button>
                            <button v-else class="btnBlue" type="submit">Agregar al carrito</button>
                        </div>
                    </div>

                    <div class="d-block d-sm-none">
                        <div v-if="product.CATEGORY === 'Bono Digital'">
                            <p class="contendTwo" v-if="product.TERMS !== null">Términos y condiciones</p>
                            <p class="contendTwo" v-if="product.TERMS !== null" v-html="product.TERMS"></p>
                            <p class="contendTwo" v-else-if="product.LONG_DESCRIPTION !== null" v-html="product.LONG_DESCRIPTION"></p>
                        </div>
                        <div v-else>
                            <p v-html="product.LONG_DESCRIPTION"></p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        product: {
            default: null,
        },
        images: {
            default: null,
        },
        url_media: {
            default: null,
        },
    },
    data() {
        return {
            loading: 0,
            amount: 1,
        }
    },
    methods: {
        addProductToCart(goToCart) {
            this.loading++
            var dataSend = {
                "product_guid": this.product.GUID,
                "product_reference_guid": this.product.REFERENCE_ID,
                "quantity": this.amount,
                "go_to_cart": goToCart,
            }
            axios.post('/create-shopping-cart', dataSend).then(
                ({data}) => {
                    console.log(data)
                    if(goToCart === true){
                        window.location.href = '/show-shopping-cart'
                    }else{
                        this.$notify({
                                         title: 'Agregado al carrito',
                                         message: 'Producto agregado al carrito Satisfactoriamente',
                                         type: 'success'
                                     });
                        this.loading--
                        setTimeout(() => {
                            window.location.reload()
                        }, 1000)
                    }
                })
        },
    },
}
</script>
